import BreadCrumb from "@/components/global/BreadCrumb";
import Tabs from "./tabs";
import UserInfoBar from "./userInfoBar";
import { getCookies } from "cookies-next";
import { useRouter } from "next/router";
import { useClient } from "@/hooks/useClient";

function DashboardLayout({ children }) {
  const { mage } = getCookies();
  const { isClient } = useClient();
  
  // const BreadCrumbItems = query?.url_key?.map((item) => {
  //   return {
  //     name: ,
  //     url: null,
  //     active: item === query?.url_key?.at(-1),
  //     key: item
  //   };
  // });

  const { locale } = useRouter();
  const BreadCrumbItems = [
    {
      name: !mage
        ? locale === "en"
          ? "Favourites"
          : "المفضلة"
        : locale == "en"
        ? "Dashboard"
        : "الملف الشخصى",
      url: !mage ? "" : "/dashboard",
      active: true,
      key: "dashboard",
    },
  ];

  return (
    <>
      <BreadCrumb items={BreadCrumbItems} />
      <div className="flex justify-center w-11/12 py-2 mx-auto sm:py-4">
        <div className="flex flex-col w-full gap-4">
          <UserInfoBar />
          {mage && isClient && <Tabs />}
          {children}
        </div>
      </div>
    </>
  );
}

export default DashboardLayout;
